import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import BlueprintStateBadge from "views/Account/Blueprints/StateBadge";

const TemplateTableStatusCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <BlueprintStateBadge state={template.state} />
    </TableSimpleCell>
  );
};

export default TemplateTableStatusCell;
